export function useFooter() {
  const allData = {
    allMenuLinkContentMenuLinkContent: {
      edges: [
        {
          node: {
            title: 'Lucid Air',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Lucid Motors',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '04ce3158-1de8-4e90-af82-456c15e44568',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'More',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Privacy',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '13dd9c1f-b33e-4c15-a586-dcca60cde3c6',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Copyright',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 4,
            drupal_id: 'f27baa06-0225-40d5-a1cf-b01e8349a11b',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'لوسِد أير',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'لوسِد موتورز',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: '04ce3158-1de8-4e90-af82-456c15e44568',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'المزيد',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Lucid Air',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Lucid Motors',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: '04ce3158-1de8-4e90-af82-456c15e44568',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Plus',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Privacy',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: '13dd9c1f-b33e-4c15-a586-dcca60cde3c6',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Lucid Air',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Lucid Motors',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: '04ce3158-1de8-4e90-af82-456c15e44568',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Meer',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: 'Privacy',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: '13dd9c1f-b33e-4c15-a586-dcca60cde3c6',
            drupal_parent_menu_item: null,
          },
        },
        {
          node: {
            title: '©2022 Lucid. All rights reserved',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '866b2f6b-8d86-4894-a8b1-529e94ef40b1',
            drupal_parent_menu_item:
              'menu_link_content:f27baa06-0225-40d5-a1cf-b01e8349a11b',
          },
        },
        {
          node: {
            title: '2022 لوسِد. جميع الحقوق محفوظة',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '866b2f6b-8d86-4894-a8b1-529e94ef40b1',
            drupal_parent_menu_item:
              'menu_link_content:f27baa06-0225-40d5-a1cf-b01e8349a11b',
          },
        },
        {
          node: {
            title: '©2022 Lucid. Tous droits réservés.',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '866b2f6b-8d86-4894-a8b1-529e94ef40b1',
            drupal_parent_menu_item:
              'menu_link_content:f27baa06-0225-40d5-a1cf-b01e8349a11b',
          },
        },
        {
          node: {
            title: '©2022 Lucid. Alle rechten voorbehouden',
            link: {
              uri_alias: 'route:<nolink>',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '866b2f6b-8d86-4894-a8b1-529e94ef40b1',
            drupal_parent_menu_item:
              'menu_link_content:f27baa06-0225-40d5-a1cf-b01e8349a11b',
          },
        },
        {
          node: {
            title: 'Discover Air',
            link: {
              uri_alias: '/air/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: 'cb2f920b-f6b9-4a1b-8138-fbcba07da2e2',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'Reserve Now',
            link: {
              uri_alias: '/air/reserve/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: 'adfc2643-b741-4632-ad4f-73baa1f92f8b',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'Design Yours',
            link: {
              uri_alias: '/air/configure/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: 'ac7f8a78-3ed3-481d-92d2-05b89d620466',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'اكتشف أير',
            link: {
              uri_alias: '/ar/air/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: 'cb2f920b-f6b9-4a1b-8138-fbcba07da2e2',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'الحجز',
            link: {
              uri_alias: '/ar/air/reserve/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: 'adfc2643-b741-4632-ad4f-73baa1f92f8b',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'صمم سيارتك',
            link: {
              uri_alias: '/ar/air/configure/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: 'ac7f8a78-3ed3-481d-92d2-05b89d620466',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'Découvrez Air',
            link: {
              uri_alias: '/fr-ca/air/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: 'cb2f920b-f6b9-4a1b-8138-fbcba07da2e2',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'Réservez dès maintenant',
            link: {
              uri_alias: '/fr-ca/air/reserve/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: 'adfc2643-b741-4632-ad4f-73baa1f92f8b',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'Concevez la vôtre',
            link: {
              uri_alias: '/fr-ca/air/configure/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 1,
            drupal_id: 'ac7f8a78-3ed3-481d-92d2-05b89d620466',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'Ontdek Air',
            link: {
              uri_alias: '/nl-nl/air/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: 'cb2f920b-f6b9-4a1b-8138-fbcba07da2e2',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'Nu reserveren',
            link: {
              uri_alias: '/nl-nl/air/reserve/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: 'adfc2643-b741-4632-ad4f-73baa1f92f8b',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'Configureren',
            link: {
              uri_alias: '/nl-nl/air/configure/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: 'ac7f8a78-3ed3-481d-92d2-05b89d620466',
            drupal_parent_menu_item:
              'menu_link_content:b5b1c2f3-fe3a-4abd-8f51-2484c127bd12',
          },
        },
        {
          node: {
            title: 'Purchase & Ownership',
            link: {
              uri_alias: '/ownership/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '9b3c150d-f940-4849-9de1-35cf2b01533f',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'FAQ',
            link: {
              uri_alias: '/faq/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: '10a500c6-b5cd-4367-b310-adeb7a12fe9e',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Events',
            link: {
              uri_alias: '/events/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 5,
            drupal_id: 'e2b77969-1b72-42d5-a0e8-4646f5559872',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Contact Us',
            link: {
              uri_alias: '/contact/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: 'b2b7bc6c-1e73-4f3b-8874-15dce27b2b89',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Locations',
            link: {
              uri_alias: '/locations/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 4,
            drupal_id: '1d4a4c35-d611-4935-a276-fc74b758f33e',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Media Room',
            link: {
              uri_alias: '/media-room/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 6,
            drupal_id: 'f3523f17-97ca-4444-be80-24761e295814',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Store',
            link: {
              uri_alias: 'https://store.lucidmotors.com/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: '883253cf-eb85-4dda-9767-2a635824fad0',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'تجربة الشراء والتملك',
            link: {
              uri_alias: '/ar/ownership/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '9b3c150d-f940-4849-9de1-35cf2b01533f',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'أسئلة وأجوبة',
            link: {
              uri_alias: '/ar/faq/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: '10a500c6-b5cd-4367-b310-adeb7a12fe9e',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'الأحداث',
            link: {
              uri_alias: '/ar/events/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 5,
            drupal_id: 'e2b77969-1b72-42d5-a0e8-4646f5559872',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'التواصل',
            link: {
              uri_alias: '/ar/contact/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: 'b2b7bc6c-1e73-4f3b-8874-15dce27b2b89',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'المواقع',
            link: {
              uri_alias: '/ar/locations/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 4,
            drupal_id: '1d4a4c35-d611-4935-a276-fc74b758f33e',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'الغرفة الإعلامية',
            link: {
              uri_alias: '/ar/media-room/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 6,
            drupal_id: 'f3523f17-97ca-4444-be80-24761e295814',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Achat et propriété',
            link: {
              uri_alias: '/fr-ca/ownership/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '9b3c150d-f940-4849-9de1-35cf2b01533f',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'FAQ',
            link: {
              uri_alias: '/fr-ca/faq/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: '10a500c6-b5cd-4367-b310-adeb7a12fe9e',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Événements',
            link: {
              uri_alias: '/fr-ca/events/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 5,
            drupal_id: 'e2b77969-1b72-42d5-a0e8-4646f5559872',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Contact',
            link: {
              uri_alias: '/fr-ca/contact/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: 'b2b7bc6c-1e73-4f3b-8874-15dce27b2b89',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Établissements',
            link: {
              uri_alias: '/fr-ca/locations/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 4,
            drupal_id: '1d4a4c35-d611-4935-a276-fc74b758f33e',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Salle des médias',
            link: {
              uri_alias: '/fr-ca/media-room/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 6,
            drupal_id: 'f3523f17-97ca-4444-be80-24761e295814',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Aanschaf en eigendom',
            link: {
              uri_alias: '/nl-nl/ownership/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '9b3c150d-f940-4849-9de1-35cf2b01533f',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'FAQ',
            link: {
              uri_alias: '/nl-nl/faq/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: '10a500c6-b5cd-4367-b310-adeb7a12fe9e',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Evenementen',
            link: {
              uri_alias: '/nl-nl/events/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 5,
            drupal_id: 'e2b77969-1b72-42d5-a0e8-4646f5559872',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Contact',
            link: {
              uri_alias: '/nl-nl/contact/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: 'b2b7bc6c-1e73-4f3b-8874-15dce27b2b89',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Vestigingen',
            link: {
              uri_alias: '/nl-nl/locations/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 4,
            drupal_id: '1d4a4c35-d611-4935-a276-fc74b758f33e',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Laatste nieuws/updates',
            link: {
              uri_alias: '/nl-nl/media-room/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 6,
            drupal_id: 'f3523f17-97ca-4444-be80-24761e295814',
            drupal_parent_menu_item:
              'menu_link_content:4c32b0ed-44a8-4c44-8f0d-207ce68edbc9',
          },
        },
        {
          node: {
            title: 'Legal',
            link: {
              uri_alias: '/legal/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: 'fbfac307-784b-475c-b6e2-3f8583fbff98',
            drupal_parent_menu_item:
              'menu_link_content:13dd9c1f-b33e-4c15-a586-dcca60cde3c6',
          },
        },
        {
          node: {
            title: 'قانوني',
            link: {
              uri_alias: '/ar/legal/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: 'fbfac307-784b-475c-b6e2-3f8583fbff98',
            drupal_parent_menu_item:
              'menu_link_content:13dd9c1f-b33e-4c15-a586-dcca60cde3c6',
          },
        },
        {
          node: {
            title: 'Juridique',
            link: {
              uri_alias: '/fr-ca/legal/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: 'fbfac307-784b-475c-b6e2-3f8583fbff98',
            drupal_parent_menu_item:
              'menu_link_content:13dd9c1f-b33e-4c15-a586-dcca60cde3c6',
          },
        },
        {
          node: {
            title: 'Juridisch',
            link: {
              uri_alias: '/nl-nl/legal/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: 'fbfac307-784b-475c-b6e2-3f8583fbff98',
            drupal_parent_menu_item:
              'menu_link_content:13dd9c1f-b33e-4c15-a586-dcca60cde3c6',
          },
        },
        {
          node: {
            title: 'Leadership',
            link: {
              uri_alias: '/company/leadership/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 1,
            drupal_id: 'fb8549f8-d957-4bcf-bc2f-2a27859392c5',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Stories',
            link: {
              uri_alias: '/stories/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 3,
            drupal_id: '3ae00bf0-a1fe-4fe7-8cd4-e3de856469b2',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Future Models',
            link: {
              uri_alias: '/future-models/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 4,
            drupal_id: '23c9c73e-5510-421c-aa03-a379b993c61b',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Investors',
            link: {
              uri_alias: 'https://ir.lucidmotors.com',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 5,
            drupal_id: '6437833a-b7b0-4cf1-bfa6-618c4fc4f2ec',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Careers',
            link: {
              uri_alias: '/careers/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 2,
            drupal_id: 'e7ede67b-0ece-4a78-a67c-04a95c910132',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Company',
            link: {
              uri_alias: '/company/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'en',
            weight: 0,
            drupal_id: '0690233d-6e60-49e5-8f03-b49bb961d418',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'القيادة',
            link: {
              uri_alias: '/ar/company/leadership/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 1,
            drupal_id: 'fb8549f8-d957-4bcf-bc2f-2a27859392c5',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'مدونات',
            link: {
              uri_alias: '/ar/stories/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 3,
            drupal_id: '3ae00bf0-a1fe-4fe7-8cd4-e3de856469b2',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'موديلات لوسد المستقبلية',
            link: {
              uri_alias: '/ar/future-models/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 4,
            drupal_id: '23c9c73e-5510-421c-aa03-a379b993c61b',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'المستثمرون',
            link: {
              uri_alias: 'https://ir.lucidmotors.com',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 5,
            drupal_id: '6437833a-b7b0-4cf1-bfa6-618c4fc4f2ec',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'فرص العمل',
            link: {
              uri_alias: '/ar/careers/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 2,
            drupal_id: 'e7ede67b-0ece-4a78-a67c-04a95c910132',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'الشركة',
            link: {
              uri_alias: '/ar/company/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'ar',
            weight: 0,
            drupal_id: '0690233d-6e60-49e5-8f03-b49bb961d418',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Histoires',
            link: {
              uri_alias: '/fr-ca/stories/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 3,
            drupal_id: '3ae00bf0-a1fe-4fe7-8cd4-e3de856469b2',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Modèles futurs',
            link: {
              uri_alias: '/fr-ca/future-models/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 4,
            drupal_id: '23c9c73e-5510-421c-aa03-a379b993c61b',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Investisseurs',
            link: {
              uri_alias: 'https://ir.lucidmotors.com',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 5,
            drupal_id: '6437833a-b7b0-4cf1-bfa6-618c4fc4f2ec',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Carrières',
            link: {
              uri_alias: '/fr-ca/careers/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 2,
            drupal_id: 'e7ede67b-0ece-4a78-a67c-04a95c910132',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Entreprise',
            link: {
              uri_alias: '/fr-ca/company/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'fr-ca',
            weight: 0,
            drupal_id: '0690233d-6e60-49e5-8f03-b49bb961d418',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Leiderschap',
            link: {
              uri_alias: '/nl-nl/company/leadership/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 1,
            drupal_id: 'fb8549f8-d957-4bcf-bc2f-2a27859392c5',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Verhalen',
            link: {
              uri_alias: '/nl-nl/stories/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 3,
            drupal_id: '3ae00bf0-a1fe-4fe7-8cd4-e3de856469b2',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Toekomstige modellen',
            link: {
              uri_alias: '/nl-nl/future-models/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 4,
            drupal_id: '23c9c73e-5510-421c-aa03-a379b993c61b',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Vacatures',
            link: {
              uri_alias: '/nl-nl/careers/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 2,
            drupal_id: 'e7ede67b-0ece-4a78-a67c-04a95c910132',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
        {
          node: {
            title: 'Bedrijf',
            link: {
              uri_alias: '/nl-nl/company/',
            },
            menu_name: '2021-footer-nav',
            langcode: 'nl-nl',
            weight: 0,
            drupal_id: '0690233d-6e60-49e5-8f03-b49bb961d418',
            drupal_parent_menu_item:
              'menu_link_content:04ce3158-1de8-4e90-af82-456c15e44568',
          },
        },
      ],
    },
  };

  const data = [];
  const lookup = {};
  const items = allData.allMenuLinkContentMenuLinkContent.edges;
  const getID = function (i) {
    return i.node.drupal_parent_menu_item.replace('menu_link_content:', '');
  };
  const addLookup = function (i) {
    lookup[i.node.drupal_id] = i.node.weight;
  };
  const buildParent = function (i) {
    const w = i.node.weight;
    const l = i.node.langcode;
    const t = i.node.title;
    if (data[w]) {
      data[w].title[l] = t;
    } else {
      data[w] = { title: { [l]: t }, order: w, children: [] };
    }
  };
  const buildChild = function (i) {
    const n = lookup[getID(i)];
    const w = i.node.weight;
    const l = i.node.langcode;
    const t = i.node.title;
    const li =
      window.location.origin + i.node.link.uri_alias.replace(/\/$/, '');
    if (data[n].children[w]) {
      data[n].children[w].title[l] = t;
      data[n].children[w].link[l] = li;
    } else {
      data[n].children[w] = { title: { [l]: t }, link: { [l]: li }, order: w };
    }
  };

  // loop through all menu items
  // if 'drupal_parent_menu_item' does NOT exist -- add parent item to 'data', add id and order to 'lookup'
  // if 'drupal_parent_menu_item' does exist -- add child item to associated parent
  items.map(
    item => (
      item.node.drupal_parent_menu_item ? buildChild(item) : buildParent(item),
      addLookup(item)
    )
  );

  return data;
}
